import styled from 'styled-components';

import { sizeDown } from '~/theme';

export const Container = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  '&.drawing-tabs': {
    maxHeight: '90%',
  },
});

export const CanvasWrapper = styled.div({
  position: 'relative',
  height: '100%',
});

export const CanvasWrapperPreviews = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  position: 'absolute',
  // below lg the canvas is too narrow for the toolbar and this preview to share the
  // bottom row, so the preview lifts by the toolbar height (~45rem) plus the gap
  bottom: sizeDown('55rem', ['lg', '10rem']),
  right: '10rem',
  alignItems: 'baseline',
});
